
    import {computed, defineComponent, onMounted, reactive, toRefs} from 'vue';
    import apiTalent from "@/request/apis/api_talent";
    import PageUtil from "@/utils/page_util";
    import {message} from "ant-design-vue/es";
    import {IArticleItem} from "@/models/article_model";
    import ApiArticle from "@/request/apis/api_article";

    interface IState {
        list: any,
        visible: any,
        title: any,
        name: any,
        searches: any,
        editId: any,
        type: any,
        pid:any,
        form:any,
    }


    export default defineComponent({
        name: 'salaryRange',
        components: {},
        setup() {
            let state: IState = reactive({
                list: [],
                visible: false,
                title: '',
                name: '',
                searches: '',
                editId: '',
                type: '',
                pid:'',
                form:'',
            })
            const columns = [
                {
                    title: 'id',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: '学校名',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '状态',
                    dataIndex: 'status',
                    key: 'status',
                },
                {
                    title: '添加时间',
                    dataIndex: 'create_time',
                    key: 'create_time',
                },
                {
                    title: '最后修改时间',
                    dataIndex: 'update_time',
                    key: 'update_time',
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    key: 'action',
                    width:150
                },
            ]



            const getList = async () => {
                const params = {...state.searches}
                const res = await apiTalent.positionList(params)
                if (res && res.error_code == 0) {
                    const data: any = res.data
                    state.list = data
                }
            }





            const onDel = async (val,val2) => {
                const params = {id: val.id,status:val2,pid:state.pid}
                const res = await apiTalent.positionStatus(params)
                if (res) {
                    message.destroy()
                    if (res.error_code === 0) {
                        message.success(res.msg)
                        await getList()
                        state.visible = false
                        return
                    }
                    message.error(res.msg)
                }
            }

            const onSearch = () => {
                getList()
            }

            const onReset = () => {
                state.searches = {
                    name:"",
                    level:3
                }
                getList()
            }



            const addRecommend = () => {
                state.visible = true
                state.title = "新增推荐"
                state.form={
                    fisrt:undefined,
                    second:undefined,
                    name:''
                }
            }

            const getSecond = async(val) => {
                if(state.type == 1){
                    state.form.second = state.form.second
                }else{
                    state.form.second = undefined
                }
                const  params = {pid:state.form.first}
                const res = await apiTalent.positionChildrenList(params)
                if (res) {
                    if (res.error_code == 0) {
                        const data:any = res.data
                    }else{
                        message.error(res.msg)
                    }
                }
            }

            const edit = (val) => {
                state.title = "编辑学校名称"
                state.form.name = val.name
                state.editId = val.id
                getSecond(1)
            }
            onMounted(() => {
                getList()
            })

            return {
                ...toRefs(state),
                columns,
                getSecond,
                edit,
                onSearch,
                onReset,
                onDel,
                addRecommend,
            }
        }
    });
